import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		maxWidth: 600,
		alignItems: 'center',
		paddingTop: SPACE[32],
		paddingLeft: 200,
		paddingRight: 200,
	},
	tabView: {
		width: '100%',
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		alignItems: 'center',
		padding: SPACE[16],
	},
	logo: {
		...CssSelectors.allChildren({
			display: 'block',
			width: 260,
		}),
	},
	signInContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		alignItems: 'center',
	},
	form: {
		width: 300,
	},
	setupSteps: {
		margin: 0,
		paddingLeft: SPACE[20],
		textAlign: 'left',
		width: '100%',
		...CssSelectors.allChildren({
			marginBottom: SPACE[8],
		}),
	},
});
